<template>
  <fragment>
    <AppBody :subtitle="subtitle" :actions="isNewRegister ? [] : actions">
      <v-row class="d-flex justify-center">
        <v-col
          cols="12"
          md="3"
          class="py-10"
          style="text-align: center"
          v-if="!$lojas_usuarios.cadastro.avatar.imagem"
        >
          <UploadIcon customizedClass="upload-icon" />
          <v-file-input
            v-model="$lojas_usuarios.cadastro.avatar.object"
            :placeholder="$t('registrations.users.choose-a-picture')"
            show-size
            accept="image/png, image/jpeg, image/bmp"
            :rules="rules"
            @change="getImagem($lojas_usuarios.cadastro.avatar.object)"
            append-icon="mdi-image-outline"
            prepend-icon=""
          >
          </v-file-input>
        </v-col>
        <v-col
          cols="12"
          md="12"
          class="py-10"
          style="text-align: center"
          v-else
        >
          <v-avatar width="150" height="150">
            <label for="imagemupload" class="avatar-label">
              <v-img
                class="img-user"
                max-height="180"
                max-width="160"
                :src="$lojas_usuarios.cadastro.avatar.imagem"
              ></v-img>
              <v-file-input
                v-model="$lojas_usuarios.cadastro.avatar.object"
                :placeholder="$t('registrations.users.choose-a-picture')"
                id="imagemupload"
                show-size
                accept="image/png, image/jpeg, image/bmp"
                :rules="rules"
                style="display: none"
                @change="getImagem($lojas_usuarios.cadastro.avatar.object)"
              ></v-file-input>
            </label>
          </v-avatar>
        </v-col>
      </v-row>
      <v-form class="search-forms">
        <v-row class="d-flex justify-center">
          <v-col cols="12" md="4">
            <label required class="input-labels">{{
              $t("registrations.users.name")
            }}</label>
            <v-text-field
              v-model="$lojas_usuarios.cadastro.nome"
              :placeholder="`Ex: ${$t('registrations.users.name-example')}`"
              solo
              type="text"
              data-cy="nome"
              class="textinput"
              :error-messages="$lojas_usuarios.cadastro.error.nome"
              @input="$lojas_usuarios.cadastro.error.nome = []"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center">
          <v-col cols="12" md="4">
            <label required class="input-labels">{{
              $t("registrations.users.email")
            }}</label>
            <v-text-field
              solo
              required
              :placeholder="$t('registrations.users.email-example')"
              v-model="$lojas_usuarios.cadastro.email"
              type="email"
              data-cy="email"
              class="textinput"
              :error-messages="$lojas_usuarios.cadastro.error.email"
              @input="$lojas_usuarios.cadastro.error.email = []"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center" v-if="isNewRegister">
          <v-col cols="12" md="4">
            <label required class="input-labels">
              {{ $t("registrations.users.password") }}
            </label>
            <v-text-field
              solo
              required
              placeholder="******"
              v-model="$lojas_usuarios.cadastro.senha"
              :type="showSenha ? 'text' : 'password'"
              :append-icon="
                showSenha ? $config.icons.viewOff : $config.icons.view
              "
              :class="[
                'textinput',
                { 'mb-6': $lojas_usuarios.cadastro.error.senha.length > 0 },
              ]"
              @click:append="showSenha = !showSenha"
              data-cy="senha"
              class="textinput"
              :error-messages="$lojas_usuarios.cadastro.error.senha"
              @input="$lojas_usuarios.cadastro.error.senha = []"
            ></v-text-field>

            <PasswordRequirements :password="$lojas_usuarios.cadastro.senha" />
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center">
          <v-col cols="12" md="4">
            <label required class="input-labels">Status</label>
            <v-select
              v-model="$lojas_usuarios.cadastro.status"
              :placeholder="$t('registrations.users.select-status')"
              height="48"
              :items="status"
              item-text="key"
              item-value="value"
              dense
              solo
              data-cy="status"
              class="textinput"
              required
              :error-messages="$lojas_usuarios.cadastro.error.status"
              @input="$lojas_usuarios.cadastro.error.status = []"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center">
          <v-col cols="12" md="4">
            <label required class="input-labels">
              {{ $t("registrations.users.profile") }}
            </label>
            <v-select
              v-model="$lojas_usuarios.cadastro.perfil"
              :placeholder="$t('registrations.users.select-profile')"
              height="48"
              item-text="key"
              item-value="value"
              dense
              :items="perfil"
              solo
              data-cy="perfil"
              class="textinput"
              required
              :error-messages="$lojas_usuarios.cadastro.error.perfil"
              @input="$lojas_usuarios.cadastro.error.perfil = []"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center" v-if="isEventProfile">
          <v-col cols="12" md="4">
            <label required class="inputs-labels">
              {{ $t("registrations.users.events") }}
            </label>
            <v-autocomplete
              v-model="$lojas_usuarios.cadastro.eventos"
              :label="$t('registrations.users.select-events')"
              :placeholder="$t('registrations.users.select-events')"
              :no-data-text="$t('registrations.users.no-events-found')"
              class="textDropdown"
              :item-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              multiple
              chips
              deletable-chips
              clearable
              solo
              required
              hide-details
              :items="allEvents"
              :loading="eventsLoading"
              item-text="descricao"
              item-value="idproduto"
              :error-messages="$lojas_usuarios.cadastro.error.eventos"
              @input="$lojas_usuarios.cadastro.error.eventos = []"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center ma-0" v-if="isEventProfile">
          <v-col cols="12" md="4" class="pb-0">
            <v-checkbox
              :label="$t('registrations.users.allow-edit-events')"
              v-model="$lojas_usuarios.cadastro.editar_evento"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-form>
      <RegistrationActions
        :loader="$lojas_usuarios.cadastro.loading"
        :actions="registrationActions"
      />
    </AppBody>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "UsersSettings",
  metaInfo() {
    const title = this.$t("registrations.users.title");
    return {
      title: `${title} | ElevenTickets`,
      meta: [
        {
          property: "og:title",
          content: `${title} | ElevenTickets`,
        },
      ],
    };
  },
  props: {},
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    RegistrationActions: () =>
      import("@/components/global/RegistrationActions.vue"),
    UploadIcon: () => import("@/components/icons/UploadIcon.vue"),
    PasswordRequirements: () =>
      import("@/components/forms/PasswordRequirements.vue"),
  },
  data() {
    return {
      showSenha: false,
    };
  },
  computed: {
    ...mapGetters(["allEvents", "eventsLoading", "storeSequencial"]),
    subtitle() {
      return this.isNewRegister
        ? this.$t("registrations.register")
        : this.$t("registrations.edit");
    },
    rules() {
      return [
        v =>
          !v ||
          v.size < 2000000 ||
          this.$t("registrations.users.image-size-error"),
      ];
    },
    actions() {
      return [
        {
          name: this.$t("registrations.users.send-info-through-email"),
          action: () => this.$lojas_usuarios.sendAppLoginInfoEmailNoPassword(),
        },
      ];
    },
    registrationActions() {
      return [
        {
          name: this.$t("registrations.save"),
          action: () => this.$lojas_usuarios.validarCadastro(),
        },
        {
          name: this.$t("registrations.cancel"),
          action: () => this.$router.push({ name: "producersUsers" }),
        },
      ];
    },
    status() {
      return [
        { key: this.$t("registrations.active"), value: "ATIVO" },
        {
          key: this.$t("registrations.users.accept-terms"),
          value: "ACEITE_TERMOS",
        },
        { key: this.$t("registrations.inactive"), value: "INATIVO" },
      ];
    },
    isNewRegister() {
      if (this.$route.params.type === "cadastrar") return true;
      else return false;
    },
    isEventProfile() {
      return this.$lojas_usuarios.cadastro.perfil === "EVENTO";
    },
    perfil() {
      return [
        { key: "App", value: "APP" },
        { key: this.$t("registrations.users.producer"), value: "LOJISTA" },
        { key: this.$t("registrations.users.admin-producer"), value: "ADMIN" },
        { key: this.$t("registrations.users.event"), value: "EVENTO" },
      ];
    },
  },
  methods: {
    ...mapActions(["fetchEvents"]),
    getImagem(file) {
      const self = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        self.$lojas_usuarios.cadastro.avatar.imagem = reader.result;
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },
  },
  mounted() {
    this.fetchEvents({ producerId: this.storeSequencial });
  },
  destroyed() {
    this.$lojas_usuarios.limpaFormularioDeUsuario();
  },
};
</script>

<style scoped>
.img-user:hover {
  cursor: pointer;
}
.upload-icon {
  height: 10rem !important;
  width: 10rem !important;
}
</style>
